import React, { useState } from 'react'
// Redux
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  getDistributionStatus,
  getOrderStatus,
  getToken,
  resetAuth,
  setToken,
  setUserInfo,
} from '../../features/auth/authSlice'
// utils
import { toast } from 'react-toastify'
import Spinner from '../../components/util/Spinner'
import { resetSetting } from '../../features/setting/settingSlice'
import { resetOrder, resetSearchSort } from '../../features/order/orderSlice'

const Login = () => {
  // Form Data
  const [userId, setUserId] = useState('')
  const [password, setPassword] = useState('')

  //   redux
  const dispatch = useDispatch()

  const [loading, setLoading] = useState(false)
  //   Login Handler
  const navigate = useNavigate()
  const loginHandler = (e) => {
    e.preventDefault()
    dispatch(resetSearchSort())
    dispatch(resetOrder())
    dispatch(resetSetting())
    dispatch(resetAuth())
    dispatch(
      getToken({
        user_id: userId,
        password,
      })
    )
      .unwrap()
      .then((res) => {
        if (res && res.data.result === 'success') {
          dispatch(setToken(res.headers.get('Authorization')))
          dispatch(getOrderStatus(res.headers.get('Authorization')))
          dispatch(getDistributionStatus(res.headers.get('Authorization')))
          dispatch(setUserInfo(res.data.value))
          setLoading(true)
          setTimeout(() => {
            setLoading(false)
            navigate('/order-status')
            setUserId('')
            setPassword('')
            toast.success('Logged in successfully')
          }, [1000])
        }
      })
      .catch((error) => {
        if (
          error.response.data.description ===
          'error login: password does not match'
        ) {
          toast.error('Bad User Credentials')
        } else {
          toast.error('Something went wrong!')
        }
      })
  }

  if (loading) return <Spinner text="Logging in..." />

  return (
    <div className="w-full min-h-screen">
      <div className="w-full min-h-[64px] bg-gray-100 mb-8 flex justify-center items-center">
        <h1 className="text-4xl text-center leading-snug py-8 text-gray-500">
          Ato Cloud 新聞折込チラシ管理システム
        </h1>
      </div>
      <div className="w-full w-12/12 flex flex-col items-center px-8">
        <h1 className="text-2xl text-center leading-snug my-8 text-gray-600">
          管理画面へログイン
        </h1>
        <form
          onSubmit={loginHandler}
          className="w-full sm:w-8/12 lg:w-5/12 flex flex-col gap-6"
        >
          <div className="flex flex-col gap-2">
            <label htmlFor="email">ID (Email)</label>
            <input
              className={inputStyle}
              type="email"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              required
            />
          </div>
          <div className="flex flex-col gap-2">
            <label htmlFor="password">Password</label>
            <input
              className={inputStyle}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {/* Button */}
          <button
            type="submit"
            className="w-max px-4 py-2 bg-primary text-white rounded-sm hover:opacity-90"
          >
            ログイン
          </button>
        </form>
      </div>
    </div>
  )
}

const inputStyle =
  'border-[1px] px-2 py-[2px] border-gray-400 outline-none focus:border-orange-400'

export default Login
